import React, { useEffect, useState } from 'react';
import PerformanceBoardSlideOutContext from '../contexts/PerformanceBoardSlideOutContext';
import useGetFieldsWhichHaveTargets from '../hooks/useGetFieldsWhichHaveTargets';
import useGetBonusCategories from '../hooks/useGetBonusCategories';
import type { GridApi } from 'ag-grid-community';

const SlideOutProvider = ({
  board,
  gridApi,
  refreshBoard,
  children,
}: {
  board: PerformanceBoardTypes.Board;
  gridApi: GridApi | undefined;
  refreshBoard: () => void;
  children: JSX.Element | JSX.Element[];
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isGridReady, setIsGridReady] = useState(false);

  const [filterInput, setFilterInput] = useState<FilterInput | undefined>();
  const [navState, setNavState] =
    useState<PerformanceBoardTypes.SlideOut.NavState>({ slideoutMode: 'Home' });
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [flashMessage, setFlashMessage] = useState<string>('');

  const { fields: performanceFields } = useGetFieldsWhichHaveTargets({
    dataType: board.dataType,
  });
  const { bonusStatusFields, bonusCategories } = useGetBonusCategories({
    dataType: board.dataType,
  });

  useEffect(() => {
    if (!gridApi) {
      return;
    }
    gridApi.addEventListener('firstDataRendered', () => {
      setIsGridReady(true);
    });
  }, [gridApi]);

  const flash = {
    isVisible,
    setIsVisible,
    flashMessage,
    setFlashMessage,
  };

  return (
    <PerformanceBoardSlideOutContext.Provider
      value={{
        board,
        isOpen: isGridReady && isOpen,
        setIsOpen,
        filterInput,
        setFilterInput,
        navState,
        setNavState,
        performanceFields,
        performanceDataset: board.dataType,
        flash,
        // TODO: Keep this?
        bonusCategories,
        // TODO: Keep this?
        bonusStatusFields,
        refreshBoard,
      }}
    >
      {children}
    </PerformanceBoardSlideOutContext.Provider>
  );
};

export default SlideOutProvider;
